var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10329 3.81663C8.47013 3.07346 9.52987 3.07346 9.89671 3.81663L11.0851 6.22409C11.2306 6.51894 11.5118 6.7234 11.8371 6.77095L14.4962 7.15962C15.3161 7.27946 15.6429 8.2873 15.0493 8.86546L13.1268 10.738C12.8909 10.9677 12.7833 11.2989 12.8389 11.6234L13.2924 14.2676C13.4325 15.0846 12.575 15.7076 11.8414 15.3217L9.46545 14.0723C9.17407 13.919 8.82593 13.919 8.53455 14.0723L6.15863 15.3217C5.425 15.7076 4.56745 15.0846 4.70757 14.2676L5.16109 11.6234C5.21675 11.2989 5.10908 10.9677 4.87321 10.738L2.95068 8.86546C2.35708 8.2873 2.68387 7.27946 3.50378 7.15962L6.16287 6.77095C6.48822 6.7234 6.76941 6.51894 6.91495 6.22409L8.10329 3.81663Z",
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOn);
export default __webpack_public_path__ + "static/media/star-on.cb2d3aff3a8258f5ec86367590941184.svg";
export { ForwardRef as ReactComponent };